<template>
  <div class="pa-4">
    <div class="banner">
      <h4>{{ $t('titles.ending_pme') }} - {{ patientName }}</h4>
    </div>

    <v-form @submit.prevent="saveEndingPme" ref="form">
      <v-row dense>
        <v-col class="d-flex flex-column align-center justify-center" cols="12" sm="12">
          <p>{{ $t('inputs.ending_pme.pme_finished') }}<span style="color: red;">*</span></p>
          <v-radio-group v-model="pmeForm.pme_finished" @change="changePmeForm()" :rules="formRules" row>
            <v-radio data-cy="radio-pme-finalizado-sim" :label="$t('options.yes')" value="SIM"></v-radio>
            <v-radio data-cy="radio-pme-finalizado-nao" :label="$t('options.not')" value="NÃO"></v-radio>
          </v-radio-group>
        </v-col>
        <template v-if="isPmeFinished">
          <v-col class="d-flex" cols="12" sm="6" v-if="isOnEndingPmeModal">
            <v-text-field
              class="rounded-lg"
              color="#256936"
              outlined
              type="datetime-local"
              :value="patientData.pme_start_datetime"
              :disabled="disablePmeStartDateTime"
              v-model="pmeForm.pme_start_datetime"
              dense
            >
              <template v-slot:label>
                {{ $t('inputs.ending_pme.pme_start_datetime') }}
              </template>
            </v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" :sm="isOnEndingPmeModal ? 6 : 12">
            <v-text-field
              data-cy="input-ultimo-exame"
              class="rounded-lg"
              color="#256936"
              :rules="formRules"
              outlined
              type="datetime-local"
              v-model="pmeForm.last_exam_datetime"
              dense
            >
              <template v-slot:label>
                {{ $t('inputs.ending_pme.last_exam_datetime') }} <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>
        </template>
        <v-col class="d-flex" cols="12" sm="12" v-if="isNotEnded">
          <v-select class="rounded-lg" @change="handleJustificationChange" :items="justifications" item-value="id" item-text="description" :rules="formRules" color="#41916b" outlined
            v-model="pmeForm.pme_justification_id" data-cy="input-pme-justification" dense>
            <template v-slot:label>
              {{ $t('inputs.ending_pme.justification') }}<span style="color: red">*</span>
            </template>
          </v-select>
        </v-col>
        <v-col class="d-flex flex-column align-center justify-center" cols="12" sm="12" v-if="isPcr && isNotEnded">
          <p>{{ $t('inputs.ending_pme.tissue_harvesting_only_flg_question') }}<span style="color: red;">*</span></p>
          <v-radio-group v-model="pmeForm.tissue_harvesting_only_flg" :rules="formRules" row>
            <v-radio data-cy="radio-continue-para-captacao" :label="$t('options.yes')" value="SIM"></v-radio>
            <v-radio data-cy="radio-abortar-pme" :label="$t('options.not')" value="NÃO"></v-radio>
          </v-radio-group>
        </v-col> 
      </v-row>
      <v-row dense>
        <v-btn class="rounded-lg" color="#e74c3c" small text elevation="0" @click="closeDialog()">
          <span>{{$t('buttons.cancel')}}</span>
        </v-btn>
        <v-spacer></v-spacer> 
        <v-btn data-cy="btn-salvar-pme" class="rounded-lg" small elevation="0" :loading="loading" color="#41916b" type="submit">
          <span class="textBtn" style="color: white">{{ btnDescription }}</span>
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import axios from "@/axios";
import Formatters from "@/utils/Formatters";
import { mapActions, mapGetters } from "vuex";
import {compareStr} from "@/utils/compareStrings";
import FormFieldsService from '@/service/FormFieldsService';
export default {
  data() {
    return { 
      loading: false,
      formRules: [(v) => !!v || this.$t('messages.required_field')],
      pmeForm: {
        id: null,
        pme_finished: null,
        pme_start_datetime: null,
        last_exam_datetime: null,
        justification: null,
        tissue_harvesting_only_flg: null,
      },
      disablePmeStartDateTime: false,
      justifications: [],
      isPcr: false,
      isProtocoloAborted: false
    }
  },
  
  props: {
    resource: {
      type: Object,
    },
  },

  async mounted() { 
    this.justifications =  await FormFieldsService.getEndingPmeReasons();
  },

  computed: {
    ...mapGetters({
      patientData: "getPatientData",
    }),

    patientName() {
      return this.patientData.name
    },

    isPmeFinished() {
      return compareStr(this.pmeForm.pme_finished, 'sim');
    },

    isNotEnded() {
      return compareStr(this.pmeForm.pme_finished, 'nao');
    }, 
    btnDescription() {
      return this.pmeForm.id ? this.$t('buttons.to_update') : this.$t('buttons.save');
    },

    showSaveAndContinue() {
      return compareStr(this.pmeForm.pme_finished, 'nao') && !this.pmeForm.id
    },

    isOnEndingPmeModal() {
      const route = this.$router.history.current.path;
        return route == '/pacientes'
    }
  },

  watch: { 
    'patientData': {
      handler(item) {
        this.checkIfHasPmeItems(item);
      },
      deep: true,
      immediate: true
    },
  },

  methods: {
    ...mapActions([
      "changeSnackBarData",
      "changePatientData"
    ]),

    handleJustificationChange(){
      const justification = this.justifications.find(
        item => item.id == this.pmeForm.pme_justification_id,
      ); 

      this.isPcr = compareStr(justification?.description, 'apresentarpcr');
    },

    checkIfHasPmeItems(patientData) { 
      const endingPmeData = patientData?.encerramento_pme || [];

      if(compareStr(endingPmeData[0]?.pme_justification?.description, 'protocoloabortado')){ 
        this.isProtocoloAborted = true 
      }

      this.pmeForm.id = endingPmeData[0]?.id ?? null;
      this.checkIfHasInitialDate(patientData); 
      this.fillPmeFinished(endingPmeData);
      this.fillEndingPmeForm(endingPmeData);
    },

    checkIfHasInitialDate(patientData) {
      const brainDeathProtocols = patientData?.brain_death_protocols;

      if(brainDeathProtocols) {
        const startingPMEDate = Formatters.dateTimeLocal(brainDeathProtocols.date_and_time_of_the_first_exam);
        const endingPMEDate = Formatters.dateTimeLocal(brainDeathProtocols.date_and_time_of_the_last_exam);

        this.pmeForm.pme_start_datetime = startingPMEDate ?? null;
        this.pmeForm.last_exam_datetime = endingPMEDate ?? null;
        this.disablePmeStartDateTime = !!this.pmeForm.pme_start_datetime;
      }
    },

    fillPmeFinished(endingPmeData) { 
      this.pmeForm.pme_finished = endingPmeData?.length ? endingPmeData[0].pme_finished : null;
    },

    fillEndingPmeForm(endingPmeData) {
      if(!compareStr(this.pmeForm.pme_finished, 'nao') || !endingPmeData?.length) return;

      const endingPme = endingPmeData[0];

      this.pmeForm.justification = endingPme.justification ?? null;
      this.pmeForm.tissue_harvesting_only_flg = endingPme.tissue_harvesting_only_flg ?? null;
      this.pmeForm.pme_justification_id = parseInt(endingPme.pme_justification_id) ?? null;
      this.isPcr = Boolean(this.pmeForm.pme_justification_id);
    },

    clearForm() {
      this.pmeForm = {
        id: null,
        pme_finished: null,
        pme_start_datetime: null,
        last_exam_datetime: null,
        justification: null,
        tissue_harvesting_only_flg: null,
      };
      this.disablePmeStartDateTime = false;
      this.$nextTick(() => {
        this.$refs.form?.resetValidation();
      });
    },

    closeDialog() {
      const route = this.$router.history.current.path;

      if (route == '/validacao-doador-me') {
        this.$router.push('/pacientes');
      } else {
        this.$emit("closeDialog");
        this.clearForm();
      }
    },

    saveEndingPme() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const pmeId = this.pmeForm.id;
        const payload = this.buildPmeForm() 

        axios({
          method: pmeId ? "PUT" : "POST",
          url: pmeId ? `/encerramento_pme/${pmeId}` : `/encerramento_pme`,
          data: payload,
        }).then((response) => {
          this.loading = false;
          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "#41916b",
            titleIcon: "mdi-checkbox-marked-circle",
          });

          setTimeout(() => {
            this.redirect()
          }, 3000);
        }).catch((err) => {
          this.loading = false;
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: this.$t('messages.something_went_wrong'),
            bodyMessage: Formatters.formatErrorMessage(err),
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        })
      }
    }, 
    
    buildPmeForm() {
      const firstExamDate = this.patientData.brain_death_protocols?.date_and_time_of_the_first_exam;

      return {
        donor_id: this.patientData.id,
        pme_finished: this.pmeForm.pme_finished,

        pme_justification_id: this.isNotEnded
          ? this.pmeForm.pme_justification_id
          : null,

        tissue_harvesting_only_flg:
          this.isNotEnded && this.isPcr
            ? this.pmeForm.tissue_harvesting_only_flg
            : null,

        ...(this.isPmeFinished && {
          date_and_time_of_the_last_exam: Formatters.isoDateTime(
            this.pmeForm.last_exam_datetime,
          ),
        }),

        ...(!firstExamDate && {
          date_and_time_of_the_first_exam: Formatters.isoDateTime(
            this.pmeForm.pme_start_datetime,
          ),
        }),
      };
    },

    redirect() {
      this.closeSnackBar(); 

      if(this.$router.history.current.path != '/validacao-doador-me') {
        this.closeDialogAndRefresh();
      }

      this.navigateAfterPmeValidation(this.getPMEStatus());
    },

    getPMEStatus() {
      const pmeNotFinished = compareStr(this.pmeForm.pme_finished, 'nao') && compareStr(this.pmeForm.tissue_harvesting_only_flg, 'nao');
      const pmeFinishedWithTissueHarvesting = compareStr(this.pmeForm.pme_finished, 'nao') && compareStr(this.pmeForm.tissue_harvesting_only_flg, 'sim');
      const pmeFinished = compareStr(this.pmeForm.pme_finished,'sim');
      const pmeAborted =  compareStr(this.pmeForm.pme_finished, 'nao') && !this.isPcr

      if(pmeNotFinished) return 'pmeNotFinished'
      if(pmeFinishedWithTissueHarvesting) return 'pmeFinishedWithTissueHarvesting'
      if(pmeFinished) return 'pmeFinished'
      if(pmeAborted) return 'pmeAborted'
    },

    navigateAfterPmeValidation(pmeStatus) {
      switch (pmeStatus) {
        case "pmeNotFinished":
          this.$router.push("/pacientes");
          break;

        case "pmeFinished":
          this.$router.push("/aceite-familiar");
          break;

        case "pmeAborted":
          this.$router.push("/pacientes");
          break;

        case "pmeFinishedWithTissueHarvesting":
          this.changePatientData({
            ...this.patientData,
            encerramento_pme: [{
                tissue_harvesting_only_flg: "SIM",
            }],
          }); 
 
          this.$router.push("/aceite-familiar");
          break;
      }
    },

    closeDialogAndRefresh() {
      this.$emit("updateGrid");
      this.closeDialog();
    },
    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
}
</script>
<style scoped>
.banner {
  background: #b3ffab;
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}
</style>